import { render, staticRenderFns } from "./DialogLayout.vue?vue&type=template&id=e8dde850&"
import script from "./DialogLayout.vue?vue&type=script&lang=js&"
export * from "./DialogLayout.vue?vue&type=script&lang=js&"
import style0 from "./DialogLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8dde850')) {
      api.createRecord('e8dde850', component.options)
    } else {
      api.reload('e8dde850', component.options)
    }
    module.hot.accept("./DialogLayout.vue?vue&type=template&id=e8dde850&", function () {
      api.rerender('e8dde850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/DialogLayout.vue"
export default component.exports